import Vue from 'vue';
import BootstrapVue from 'bootstrap-vue';
import Notifications from 'vue-notification';
import Alerts from 'vue-sweetalert2';
import Clipboard from 'vue-clipboard2';
import AddToCalendar from 'vue-add-to-calendar';
import VueScrollTo from 'vue-scrollto';
import AOS from 'aos';
import VueGtag from 'vue-gtag';
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';
import 'aos/dist/aos.css';
import 'vue-multiselect/dist/vue-multiselect.min.css';
import 'sweetalert2/dist/sweetalert2.min.css';
import '@sweetalert2/theme-bootstrap-4/bootstrap-4.min.css';
import '@fullcalendar/core/main.css';
import '@fullcalendar/daygrid/main.css';
import '@fullcalendar/timegrid/main.css';
import '@fullcalendar/list/main.css';

import App from './App.vue';
import router from './router';
import store from './store';
import { extend } from 'vee-validate';
import * as rules from 'vee-validate/dist/rules';
import { messages } from 'vee-validate/dist/locale/en.json';
import './assets/scss/app.scss';

Object.keys(rules).forEach(rule => {
  extend(rule, {
    ...rules[rule],
    message: messages[rule]
  });
});

Vue.use(BootstrapVue);
Vue.use(Notifications);
Vue.use(Alerts);
Vue.use(Clipboard);
Vue.use(AddToCalendar);
Vue.use(VueScrollTo);

Vue.component('VueCtkDateTimePicker', VueCtkDateTimePicker);

Vue.use(
  VueGtag,
  {
    config: {
      id: 'G-FLWJSMSZ1G'
    }
  },
  router
);

Vue.config.productionTip = false;

new Vue({
  created() {
    AOS.init();
  },
  router,
  store,
  render: h => h(App)
}).$mount('#app');
